import PropTypes from 'prop-types'
import React from 'react'

import Event from 'base/event'
import Hub from 'base/hub'

import Link from 'base/react/components/link'
import NotificationProvider from 'base/containers/notifications/provider'
import NotificationList from 'base/components/notifications/list'

const links = [
  {
    key: 'info',
    title: 'Account',
    url: '/account/info',
  },
  {
    key: 'orders',
    title: 'Orders & Returns',
    url: '/account/orders',
  },
  {
    key: 'redeem',
    title: 'Redeem a Gift Card',
    url: '/redeem',
  },
  {
    key: 'invite',
    title: 'Invite',
    url: '/invite?source=menu',
  },
  {
    key: 'help-center',
    title: 'Help Center',
    url: 'https://support.everlane.com/',
  },
]

function AccountDropdownV2({
  onRequestLogOut,
  showAdminLink,
  isSignedIn,
  handleToggleAccountDropdown,
  showAccountDropdown,
  onToggleLogInModal,
  onToggleSignUpModal,
}) {
  const handleAccountClick = path => {
    Hub.pub(Event.Navigation.ACCOUNT_CLICK, {
      type: path,
      menu_type: 'dropdown',
    })
  }

  if (isSignedIn) {
    const items = links.map(link => (
      <li key={link.url} className="account-dropdown-v2__link">
        <Link
          href={link.url}
          onClick={() => {
            handleAccountClick(link.key)
            handleToggleAccountDropdown()
          }}
        >
          {link.title}
        </Link>
      </li>
    ))

    if (showAdminLink) {
      items.unshift(
        <li key="admin" className="account-dropdown-v2__link">
          <Link href="/admin" target="_blank">
            <span className="account-dropdown-v2__link">Go to Admin Site</span>
          </Link>
        </li>,
      )
    }

    items.push(
      <li key="logout" className="account-dropdown-v2__link">
        <Link
          onClick={() => {
            onRequestLogOut()
            handleToggleAccountDropdown()
          }}
        >
          Log Out
        </Link>
      </li>,
    )

    return (
      <div
        className="account-dropdown-v2"
        style={!showAccountDropdown ? { visibility: 'hidden' } : { visibility: 'visible' }}
      >
        <h1 className="account-dropdown-v2__header">Your Account</h1>
        <ul className="account-dropdown-v2__links-container">{items}</ul>

        <NotificationProvider>
          <NotificationList
            className="account-dropdown-v2__notification-list"
            itemClassName="account-dropdown-v2__notification"
          />
        </NotificationProvider>
      </div>
    )
  }

  return (
    <div
      className="account-dropdown-v2"
      style={!showAccountDropdown ? { visibility: 'hidden' } : {}}
    >
      <h1 className="account-dropdown-v2__header">Welcome</h1>

      <ul className="account-dropdown-v2__links-container">
        <li key="login" className="account-dropdown-v2__link">
          <Link onClick={() => onToggleLogInModal({ isVisible: true })}>Log In</Link>
        </li>
        <li key="sign-up" className="account-dropdown-v2__link">
          <Link onClick={() => onToggleSignUpModal({ isVisible: true })}>Sign Up</Link>
        </li>
        <li key="help-center" className="account-dropdown-v2__link">
          <Link href="https://support.everlane.com/">Help Center</Link>
        </li>
      </ul>
    </div>
  )
}

AccountDropdownV2.propTypes = {
  onRequestLogOut: PropTypes.func.isRequired,
  showAdminLink: PropTypes.bool.isRequired,
  isSignedIn: PropTypes.bool.isRequired,
  handleToggleAccountDropdown: PropTypes.func.isRequired,
  showAccountDropdown: PropTypes.bool,
}

export default AccountDropdownV2
